﻿
angular.module('fliptoWeb').directive('ftCarouselFeatures', ['$location', function ($location) {
    "use strict";

    function link(scope, element, attrs) {

        var prestay = new Slide({
            name: 'prestay',
            title: 'Pre-stay Advocacy',
            titleClass: 'prestay',
            image: '/assets/images/areas/features/layer-panel-prestay.png',
            text: 'Turn the excitement of booking a trip into a message with worldwide reach',
            url: '/features/prestay-advocacy',
            active: false,
            order: 0
        });

        var poststay = new Slide({
            name: 'poststay',
            title: 'Post-stay Advocacy',
            titleClass: 'poststay',
            image: '/assets/images/areas/features/layer-panel-poststay.png',
            text: 'A reimagined post-stay interaction that builds the strongest brand connections possible.',
            url: '/features/poststay-advocacy',
            active: false,
            order: 1
        });

        var photoAdvocacy = new Slide({
            name: 'photoAdvocacy',
            title: 'Photo Advocacy',
            titleClass: 'photo',
            image: '/assets/images/areas/features/layer-panel-photo.png',
            text: 'Let your guests share their fondest memories, and tap into the creativity and unique perspectives that only your guests can provide.',
            url: '/features/photo-advocacy',
            active: false,
            order: 2
        });

        var superchargers = new Slide({
            name: 'siteSuperchargers',
            title: 'Site Superchargers',
            titleClass: 'superchargers',
            image: '/assets/images/areas/features/layer-panel-superchargers.png',
            text: 'Add personality and give site visitors a compelling incentive to book direct.',
            url: '/features/site-superchargers',
            active: false,
            order: 3
        });

        function Slide(obj) {
            this.name = obj.name;
            this.title = obj.title;
            this.titleClass = obj.titleClass,
            this.image = obj.image,
            this.text = obj.text,
            this.url = obj.url,
            this.active = obj.active,
            this.order = obj.order
        }

        Slide.prototype.navigate = function () {
            $location.url(this.url);
        }

        var nextActive = 0;

        var availSlides = [prestay, poststay, photoAdvocacy, superchargers];

        scope.owner = attrs.owner;

        scope.slides = [];

        scope.next = function () {
            var next = 0;
            angular.forEach(scope.slides, function (slide, index) {
                if (slide.active) {
                    next = index === scope.slides.length -1? 0: index + 1;
                    slide.active = false;
                    return;
                }
            })

            scope.slides[next].active = true;
        }

        scope.prev = function () {
            var next = 0;

            angular.forEach(scope.slides, function (slide, index) {
                if (slide.active) {
                    next = index === 0? scope.slides.length -1: index - 1;
                    slide.active = false;
                    return;
                }
            })

            scope.slides[next].active = true;
       }

        scope.getSlide = function (slideOrder) {
            angular.forEach(scope.slides, function (slide) {
                if (slide.active) {
                    slide.active = false;
                    return;
                }
            })

            scope.slides[slideOrder].active = true;
        }

        angular.forEach(availSlides, function (item) {
            if (item.name != scope.owner) {
                scope.slides.push(item);
            } else {
                if (item.order >= availSlides.length -1)
                    nextActive = 0;
                else
                    nextActive = item.order;
            }
        });

        scope.slides[nextActive].active = true;
    }

    return {
        restrict: 'AE',
        replace: true,
        templateUrl: 'ft-carousel-features.html',
        scope: {
            owner: '='
        },
        link: link
    };
}]);